import { useAuthProvider } from 'react-admin';
import { AdminGroup } from 'src/constants/roles';

export class ScheduleManager {
    static isCalendarEventEdit = (): boolean => {
        const authProvider = useAuthProvider();
        return authProvider?.containsRoles([...AdminGroup]) ?? false;
    };

    static isTooltipEventCardAvailable = (isEventCardContent: boolean, isEventInSameTimeSlot: boolean): boolean => {
        return this.isCalendarEventEdit() || isEventCardContent || isEventInSameTimeSlot;
    };
}
